import getValidFolderPaneWidth from './getValidFolderPaneWidth';
import { setShowFolderPane } from '../actions/setShowFolderPane';
import logFolderPaneState from '../helpers/logFolderPaneState';
import { default as setFolderPaneWidth } from '../legacyActions/setFolderPaneWidth';
import initializeListViewColumnWidths from '../mutators/initializeListViewColumnWidths';
import { initializeFavoritesPaneHeightMutator } from '../mutators/favoritesPaneHeightMutators';
import { setShowAllAccountsNodeMutator } from '../mutators/setShowAllAccountsNodeMutator';
import {
    getIsBitSet,
    type ListViewBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { initializeDynamicLayout, LayoutChangeSource } from 'owa-layout';
import { areDisplayAdsShown } from 'owa-mail-ads-checker';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import initializeSingleLineViewWithRightReadingPane from '../mutators/initializeSingleLineWithRightReadingPane';
import { initializeAnimations } from './initializeAnimations';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { initializeMailOrganizationSettings } from 'owa-mail-organization-settings';
import { initializeMailOrganizationViewTypes } from 'owa-mail-organization-viewtypes-settings';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getItem } from 'owa-local-storage';

export function initializeMailLayout(): void {
    /**
     * On init try to validate the folder pane width (NavigationBarWidth)
     */
    const storedFolderPaneWidth = getValidFolderPaneWidth(
        getUserConfiguration().UserOptions?.NavigationBarWidth,
        LayoutChangeSource.Init
    );

    // Set folder pane width
    setFolderPaneWidth(storedFolderPaneWidth);

    const showFolderPane = !getIsBitSet(4, getGlobalSettingsAccountMailboxInfo());
    setShowFolderPane(showFolderPane);
    logFolderPaneState(LayoutChangeSource.Init, showFolderPane, showFolderPane);

    initializeListViewColumnWidths();
    initializeFavoritesPaneHeightMutator();
    initializeSingleLineViewWithRightReadingPane();
    initializeAnimations();

    initializeDynamicLayout(areDisplayAdsShown());

    initializeMailOrganizationSettings();

    if (isGlobalFeatureEnabled('rp-momocoSettings')) {
        initializeMailOrganizationViewTypes();
    }

    if (isGlobalFeatureEnabled('acct-unifiedInbox')) {
        // UnifiedInbox does not belong to any specific account, we will use local storage to persist the state
        // Initialize the showAllAccountsNode based on local storage value
        setShowAllAccountsNodeMutator(getItem(window, 'IsUnifiedInboxFolderTreeHidden') !== 'true');
    }
}
